import { render, staticRenderFns } from "./support.vue?vue&type=template&id=3ef5d9b8&scoped=true"
import script from "./support.vue?vue&type=script&lang=js"
export * from "./support.vue?vue&type=script&lang=js"
import style0 from "./support.vue?vue&type=style&index=0&id=3ef5d9b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef5d9b8",
  null
  
)

export default component.exports